import Vue from 'vue'
import MessageManager from './message/manager'

const debug = false

export default (carrier) => {
  return new Vue({
    data () {
      return {
        objects: {},
        messages: new MessageManager(this)
      }
    },
    computed: {
      subscriptions () {
        return Object.keys(this.objects)
      }
    },
    watch: {
      subscriptions (newSubscriptions, oldSubscriptions) {
        const toSubscribe = newSubscriptions.filter(subscription => !oldSubscriptions.includes(subscription))
        const toUnsubscribe = oldSubscriptions.filter(subscription => !newSubscriptions.includes(subscription))

        if (carrier.websocket) {
          if(debug) console.log('[CARRIER] Sub/Unsub', toSubscribe, toUnsubscribe)
          if (toSubscribe.length > 0) carrier.websocket.emit('subscribe', toSubscribe)
          if (toUnsubscribe.length > 0) carrier.websocket.emit('unsubscribe', toUnsubscribe)
        }
      }
    },
    methods: {
      has (path) {
        return path in this.objects
      },
      add (path, owner, data) {
        if (this.has(path)) {
          if(!this.objects[path].owners.includes(owner)) {
            this.objects[path].owners.push(owner)
          }
          return false
        } else {
          this.$set(this.objects, path, {
            data,
            owners: [owner]
          })
          return true
        }
      },
      update (path, data) {
        if (this.has(path)) {
          this.objects[path].data = data
          this.objects[path].__ob__.dep.notify() // TODO: CHECK IF REQUIRED
        } else {
          return false
        }
      },
      set (path, owner, data) {
        if (this.has(path)) {
          this.update(path, data)
        } else {
          this.add(path, owner, data)
        }
      },
      get (path, missing) {
        if (this.has(path)) {
          return this.objects[path].data
        } else {
          return missing
        }
      },
      list (owner) {
        return Object.fromEntries(Object.entries(this.objects).filter(entry => {
          return entry[1].owners.includes(owner)
        }))
      },
      remove (owner, path) {
        if (!path) {
          for (const { path } of this.list(owner)) {
            this.remove(owner, path)
          }
        } else {
          if (this.has(path)) {
            this.objects[path].owners = this.objects[path].owners.filter(id => id !== owner)
            if (this.objects[path].owners.length === 0) {
              this.$delete(this.objects, path)
            }
          }
        }
      },

      subscribe () {
        if (carrier.websocket) {
          carrier.websocket.on('messages', messages => {
            this.messages.dispatch(messages)
          })

          carrier.websocket.io.on('reconnect', () => {
            carrier.websocket.emit('subscribe', this.subscriptions)
          })
        } else {
          setTimeout(() => this._listenWebsocket(), 5000)
        }
      }
    },
  })
}